import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
  name: 'maxLength'
})
export class MaxLengthPipe implements PipeTransform {

  transform(value: string, opt?: number): string {
    if (opt && value.length >= opt) {
      return value.substring(0, opt).concat('...');
    } else {
      if (value.length > 100) {
        return value
          .substring(0, 100)
          .concat('...');
      }
    }

    return value;
  }

}
